import React from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { AddonConsumptionType as AddonConsumptionTypeIds } from '../constants';
import { useTextResources } from '../../../language';
import { pickBy } from '../utils';

const AddonsConsumptionTypesDropDown = ({ consumptionTypesIds = [], ...props }) => {
  const text = useTextResources();

  //If provided with ConsumptionTypesIds, use only those. Otherwise, use the entire Enum
  const options = consumptionTypesIds.length
    ? pickBy(AddonConsumptionTypeIds, (key) => consumptionTypesIds.includes(key))
    : AddonConsumptionTypeIds;

  const data = Object.entries(options).reduce((acc, [key, value]) => {
    acc.push({
      text: text(key),
      value,
    });
    return acc;
  }, []);

  return (
    <DropDown textField='text' valueField='value' data={data} {...props} />
  );
};

AddonsConsumptionTypesDropDown.propTypes = {
    consumptionTypesIds: PropTypes.array,
};

export default AddonsConsumptionTypesDropDown;
